import type {ScreenViewName} from '@deezer/next/services/tracking/LogCenter/events/types';
import {CampaignStatuses} from '@deezer/next/services/api/Starmania/requests/campaigns/types';

export type ScreenViewEventType = {
	type: 'cdp';
	eventName: 'screen_view';
	customAttributes: {
		screen_view_name: string;
	};
};

export type CustomAttributesType = {
	screen_view_id_type?: string;
	screen_view_id?: string;
};

export const getScreenViewEvent = (
	...args: [screenName: ScreenViewName, customAttributes?: CustomAttributesType]
): ScreenViewEventType => {
	const [screenName, customAttributes] = args;

	return {
		type: 'cdp',
		eventName: 'screen_view',
		customAttributes: {
			screen_view_name: screenName,
			...customAttributes,
		},
	};
};

export const formatLogCampaignStatus = (status: CampaignStatuses) => {
	switch (status) {
		case CampaignStatuses.APPROVED:
			return 'approved';
		case CampaignStatuses.DENIED:
			return 'denied';
		case CampaignStatuses.DONE:
			return 'done';
		case CampaignStatuses.PENDING:
			return 'pending';
		case CampaignStatuses.REPORT_READY:
			return 'report_ready';
		case CampaignStatuses.RUNNING:
			return 'running';
		case CampaignStatuses.WAITING_IO:
			return 'waiting_io';
		default:
			return 'approved';
	}
};
